import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: none;\n  margin-left: 1px;\n  margin-top: 1px;\n  min-height: ", ";\n  width: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  transform: rotate(", ");\n  transition: transform ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n  margin-right: ", ";\n  transition: fill ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  /* to move action button over main button */\n  margin-left: -", "px;\n  position: relative;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      &::before {\n        background-color: ", ";\n        content: '';\n        display: block;\n        height: ", "px;\n        position: absolute;\n        right: 28px;\n        transition: background-color ", ";\n        width: 1px;\n      }\n\n      &:hover {\n        &::before {\n          background-color: ", ";\n        }\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  color: ", ";\n  cursor: ", ";\n  display: inline-flex;\n  flex-direction: row;\n  font-size: ", ";\n  font-weight: ", ";\n  justify-content: center;\n  margin: 0;\n  min-height: ", "px;\n  text-decoration: none;\n  transition: background-color ", ", color ", ",\n    border ", ";\n  width: ", ";\n\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n    text-decoration: none;\n  }\n\n  &[disabled] {\n    cursor: not-allowed;\n\n    /* hide styles added by withRippleEffect() */\n    &::before {\n      display: none;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { color, size, property, typography } from '@scp/ui-shared/theme/variables';
import { baselineToPx, rem } from '@scp/ui-shared/theme/utils';
import { ALT_BUTTON_APPEARANCE, ALT_BUTTON_SIZE } from './constants';
export var getPadding = function getPadding(_ref) {
  var hasIcon = _ref.hasIcon,
      hasActions = _ref.hasActions;

  if (hasIcon && !hasActions) {
    return "0 ".concat(baselineToPx(4), " 0 ").concat(baselineToPx(2));
  }

  if (hasIcon && hasActions) {
    // action button width + main button padding
    return "0 ".concat(ALT_BUTTON_SIZE.size + size.baseline * 2, "px 0 ").concat(baselineToPx(2));
  }

  if (!hasIcon && hasActions) {
    // action button width + main button padding
    return "0 ".concat(ALT_BUTTON_SIZE.size + size.baseline * 2, "px 0 ").concat(baselineToPx(4));
  }

  return "0 ".concat(baselineToPx(4));
};
export var getBorderColor = function getBorderColor(props) {
  if (props.disabled) {
    return props.appearance === ALT_BUTTON_APPEARANCE.DANGER ? "".concat(color.palette.red900) : "".concat(color.palette.grey800);
  }

  switch (props.appearance) {
    case ALT_BUTTON_APPEARANCE.SECONDARY:
      return "".concat(color.palette.grey800);

    case ALT_BUTTON_APPEARANCE.DANGER:
      return "".concat(color.palette.red500);

    default:
      return "".concat(color.palette.blue500);
  }
};
export var getBackgroundColor = function getBackgroundColor(props) {
  if (props.disabled) {
    return props.appearance === ALT_BUTTON_APPEARANCE.DANGER ? "".concat(color.palette.red900) : "".concat(color.palette.white);
  }

  switch (props.appearance) {
    case ALT_BUTTON_APPEARANCE.SECONDARY:
      return "".concat(color.palette.white);

    case ALT_BUTTON_APPEARANCE.DANGER:
      return "".concat(color.palette.red500);

    default:
      return "".concat(color.palette.blue50);
  }
};
export var getBackgroundHoverColor = function getBackgroundHoverColor(props) {
  if (props.disabled) return;

  switch (props.appearance) {
    case ALT_BUTTON_APPEARANCE.DANGER:
      return "".concat(color.palette.red450);

    default:
      return "".concat(color.palette.grey900);
  }
};
export var getBorderHoverColor = function getBorderHoverColor(props) {
  if (props.disabled) return;

  switch (props.appearance) {
    case ALT_BUTTON_APPEARANCE.DANGER:
      return "".concat(color.palette.red450);

    default:
      return "".concat(color.palette.grey800);
  }
};
export var getTextColor = function getTextColor(props) {
  if (props.appearance === ALT_BUTTON_APPEARANCE.DANGER) return "".concat(color.palette.white);
  if (props.disabled) return "".concat(color.palette.grey700);
  return "".concat(color.palette.grey200);
};
export var buttonWrapperBase = css(_templateObject(), function (props) {
  return props.fullWidth ? '100%' : 'auto';
});
export var buttonBase = css(_templateObject2(), getBackgroundColor, getBorderColor, property.borderRadius, getTextColor, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, rem(ALT_BUTTON_SIZE.fontSize), typography.fontWeightSemiBold, ALT_BUTTON_SIZE.size, property.transition, property.transition, property.transition, function (props) {
  return props.fullWidth ? '100%' : 'auto';
}, getBackgroundHoverColor, getBorderHoverColor, getTextColor);
export var mainButtonBase = css(_templateObject3(), getPadding, function (props) {
  return props.hasActions && css(_templateObject4(), getBorderColor, ALT_BUTTON_SIZE.size, property.transition, getBorderHoverColor);
});
export var actionsWrapperBase = css(_templateObject5(), ALT_BUTTON_SIZE.size);
export var buttonIconBase = css(_templateObject6(), function (props) {
  return props.disabled || !props.iconColor ? 'currentColor' : props.iconColor;
}, baselineToPx(1), property.transition);
export var arrowIconBase = css(_templateObject7(), function (props) {
  return props.isOpen ? '-180deg' : '0';
}, property.transition);
export var actionsButtonBase = css(_templateObject8(), baselineToPx(7), baselineToPx(7));